import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { CUSTOMER_TRAVELPLANS } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { getSanctumBearerToken } from '~/helpers/sanctumAuth';
import {
  CustomerTravelplansRequest,
  CustomerTravelplansResponse,
} from '~/types/api';
import { MutationError } from '~/types/form';
import { CustomerTravelplansRequestSchema, CustomerTravelplansResponseSchema } from '~/validation/api/customerTravelplansResponse';

export const getCustomerTravelplans = async (obj: CustomerTravelplansRequest) => {
  const body = CustomerTravelplansRequestSchema.parse(obj);

  try {
    const response = await axios.post(CUSTOMER_TRAVELPLANS, body, {
      headers: {
        Authorization: getSanctumBearerToken(),
      },
    });

    const json = response.data;

    return CustomerTravelplansResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export function useCustomerTravelplans(obj: CustomerTravelplansRequest) {
  return useQuery<CustomerTravelplansResponse, MutationError>({
    queryKey: ['customerTravelplans', obj.page, obj.per_page],
    queryFn: () => {
      return getCustomerTravelplans(obj);
    },
    retry: false,
  });
}
